import { isObject } from 'lodash';
import React, { FunctionComponent } from 'react';
import { Box, Flex, Text } from 'rebass/styled-components';
import { lookupExceptionStr, PolicyVariablesProps, UNDEFINED_POLICY_VARIABLE_DISPLAY } from '.';
import { ElidableText } from '..';

interface VariableValueDisplayProps {
  variable: string;
  valueMap: { [key: string]: string };
  exceptionsMap: { [key: string]: string };
}

const VariableValueDisplay: FunctionComponent<VariableValueDisplayProps> = ({
  variable = '', valueMap = {}, exceptionsMap = {},
}: VariableValueDisplayProps) => {
  if (!variable) {
    return null;
  }
  const successValue = valueMap[variable];
  if (successValue != null) {
    return (
      <Text variant="primary">
        <ElidableText text={successValue.toString()} />
      </Text>
    );
  }
  const exceptionValue = lookupExceptionStr(variable, exceptionsMap);
  if (exceptionValue) {
    return (
      <Text variant="primary">
        <Text variant="error">
          <ElidableText text={exceptionValue} />
        </Text>
      </Text>
    );
  }
  return (
    <Text variant="primary">{UNDEFINED_POLICY_VARIABLE_DISPLAY}</Text>
  );
};

const PolicyVariablesTable: FunctionComponent<
PolicyVariablesProps
> = ({ variables = [], valueMap = {}, exceptionsMap = {} }: PolicyVariablesProps) => (
  <Flex flexDirection="column" mt={2} mb={1} data-testid="policy-variables-table">
    <Flex flexDirection="row" flexWrap="nowrap" mb={2}>
      <Box width={400} flexShrink={0}>
        <Text variant="h5" sx={{ textTransform: 'uppercase' }}>Context Attribute Name</Text>
      </Box>
      <Box>
        <Text variant="h5" sx={{ textTransform: 'uppercase' }}>Value</Text>
      </Box>
    </Flex>
    <Box>
      {variables?.map((variable: string) => {
        const successValue = valueMap[variable];
        if (successValue != null && !Array.isArray(successValue) && isObject(successValue)) {
          return null;
        }
        return (
          <Flex
            key={`variable_${variable}`}
            flexDirection="row"
            flexWrap="nowrap"
            mb={1}
            data-testid="policy-variables-table-entry"
          >
            <Box width={400} pr={3} variant="flexTableCell">
              <Text
                variant="primary"
                sx={{
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
                data-testid="policy-variables-table-key"
              >
                {variable}
              </Text>
            </Box>
            <Box
              pr={3}
              sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
              data-testid="policy-variables-table-value"
            >
              <VariableValueDisplay
                variable={variable}
                valueMap={valueMap}
                exceptionsMap={exceptionsMap}
              />
            </Box>
          </Flex>
        );
      })}
    </Box>
  </Flex>
);
export default PolicyVariablesTable;
